import type {
	ButtonItemConfig,
	CustomItemConfig,
	ExpandableItemConfig,
	FlyoutItemConfig,
	LinkItemConfig,
	NavItemConfig,
	ObjectListFlyoutItemConfig,
} from '@atlassian/navigation-common/types';

export const isButtonItemConfig = (item: NavItemConfig): item is ButtonItemConfig =>
	item.type === 'button';

export const isCustomItemConfig = (item: NavItemConfig): item is CustomItemConfig =>
	item.type === 'custom';

export const isExpandableItemConfig = (item: NavItemConfig): item is ExpandableItemConfig =>
	item.type === 'expand';

export const isFlyoutItemConfig = (item: NavItemConfig): item is FlyoutItemConfig =>
	item.type === 'flyout';

export const isLinkItemConfig = (item: NavItemConfig): item is LinkItemConfig =>
	item.type === 'link';

export const isObjectListFlyoutItemConfig = (
	item: NavItemConfig,
): item is ObjectListFlyoutItemConfig => item.type === 'object-list-flyout';
